import { config } from '../config';

const errorMessage = '[apiTrials] error to method';

export const apiTrials = {
  getTrialInfo: async (axiosPrivate, trialId) => {
    try {
      const response = await axiosPrivate.get(`${config.API.TRIALS.INFO}/${trialId}`);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'getTrialInfo', error);
      throw error;
    }
  },
  checkAvailability: async (axiosPrivate, trialId) => {
    try {
      const response = await axiosPrivate.get(`${config.API.TRIALS.CHECK}/${trialId}`);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'checkAvailability', error);
      throw error;
    }
  },
  useTrial: async (axiosPrivate, trialId, currency) => {
    try {
      const response = await axiosPrivate.post(`${config.API.TRIALS.USE}/${trialId}`, { currency });
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'useTrialBonus', error);
      throw error;
    }
  },
};
